import {ICON_BUTTON_CLICK_TARGET} from '../models/cta.model';
import {snippetService} from './snippet.service';

export const logIconButtonClick = (icon: ICON_BUTTON_CLICK_TARGET): void => {
	snippetService.sendCtaClickMessage(icon as string);
};
